/* eslint-disable no-use-before-define */
import { $Q, $Qll } from "../utils/query-selector";
import { optionsChecked } from "./variants-product";

/**
 *
 * Validate if the funnel structure is found.
 *
 */
export const funnelValidation = () => {
  const funnelObject = $Q('.funnel-js');

  if (funnelObject) {
    structureJSONfilter(funnelObject);
  }
}

/**
 * Structure the JSON element within
 * the funnel and validate how many variant options exist.
 *
 * @param {HTMLElement} parent - Dom element parent of all seletors options
 *
 */
export const structureJSONfilter = (parent) => {
  const variants = JSON.parse($Q('#variants', parent).value);

  unavailableOptions(variants, parent);
}

/**
 * Structure the JSON element within
 * the funnel and validate how many variant options exist.
 *
 * @param {HTMLElement} parent - Dom element parent of all seletors options
 *
 */
function unavailableOptions(variants, parent) {
  const variantsFilter = optionsChecked(parent, true);
  let index = 0;
  let optionNumber = 1;

  variantsFilter.forEach((element) => {
    const label = `label-option${optionNumber}`;

    const variantFilter = variants.filter((variant) => (
      variant.options[index] === element && variant.available === false
      ),
    )

    blockVariantoption(variantFilter, label, index);

    index++;
    optionNumber++;
  });
}

/**
 * Add the class block element for the associated option variables
 *
 * @param {node} variantFilter - name of the variant
 * or variants that not have stock
 * @param {string} labelcontent - class asociated
 * to all labels variants for unselect the class
 * @param {string} index - option selected in the filter
 *
 */
function blockVariantoption(variantFilter, labelcontent, index) {
  $Qll('.variant__label').forEach((element) => {
    if (!element.classList.contains(labelcontent)) {
      element.classList.remove('notstock')
    }
  });

  variantFilter.forEach((element) => {
    let i = 0;

    element.options.forEach((optionValue) => {
      const refOption = $Q(`.op-stock-js[data-option="${handleize(optionValue)}"]`)

      if (i !== index && refOption) {
        refOption
          .classList
          .add('notstock')
      }

      i++;
    });
  });
}

function handleize(str) {
  return str
    .toLowerCase()
    .replace("'", '')
    .replace(/[^\w\u00C0-\u024f]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}
